import React from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";

import HeroImage from "../../assets/images/hero-slushy.jpg";

import ComboDrinks from "../../assets/images/beverages-combo.jpg";

import MargaritaAccordian from "../../components/MargaritaAccordion/margarita";

import KidsDrink from "../../assets/images/kids-slush.png";
import Slush from "../../assets/images/BigBiz2.png";

import "./Beverages.css";

function Beverages() {
  return (
    <div>
      <Helmet>
        <title>Beverages</title>
      </Helmet>
      
      <Header />

      {/* Hero section */}
      <HeroSection
        backgroundImage={HeroImage}
        title="Real Fruit, Natural Flavours"
        subtitle="Blendz Beverages"
        dividerPath="M0,256L48,234.7C96,213,192,171,288,149.3C384,128,480,128,576,154.7C672,181,768,235,864,266.7C960,299,1056,309,1152,277.3C1248,245,1344,171,1392,133.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="white"
      />

      <div className="BeveragesContainer">
        {/* Margarita accordian */}
        <div className="BeveragesContent" style={{ marginBottom: "0" }}>
          <div className="ImageContainer">
            <img alt="Group of slush drinks" src={ComboDrinks} />
          </div>

          <h2>Looking for inspiration? Try these:</h2>
          <MargaritaAccordian />
        </div>

        {/* Kids drink section */}

        <div
          className="ImgTextSection"
          style={{ paddingTop: "0", marginTop: "0" }}
        >
          <div className="SectionLeft">
            <div className="TextContainer">
              <h2>Natural mixes for kids</h2>
              <h3>Made Natural, Direct from Nature</h3>

              <p>
                Try out: Blueberry, Blue Lemonade, Lime, Raspberry, Pineapple, or Orange
              </p>
              <p>Our kids' drinks are made from natural ingredients.</p>

              <p>
                <strong>Looking for something classic?</strong> While not
                all-natural, our Cola remains an all-time favorite!
              </p>
            </div>
          </div>
          <div className="SectionRight">
            <div className="ImageContainer">
              <img
                src={KidsDrink}
                alt="Blendz slushy machine"
                className="ContentImages"
              />
            </div>
          </div>
        </div>

        <div
          className="ImgTextSection"
          style={{ backgroundColor: "var(--shading-colour)", padding: "0" }}
        >
          <div className="SectionLeft">
            <div className="TextContainer" style={{paddingLeft: "100px"}}>
              <h2>How to Prepare Cocktails</h2>
              <ol>
                <li>Measure Ingredients</li>
                <dt>
                  - Use 1L Blendz mix, 3.5L water, and 500ml white spirit.
                </dt>
                <li>Pour Ingredients into a Granita Machine</li>
                <dt>- Set to freeze mode.</dt>
                <li>Wait 20 - 30 Minutes</li>
                <dt>- Chilled mix is ready to serve.</dt>
                <li>Serve & Garnish</li>
                <dt>- Use 250ml martini or margarita glasses.</dt>
              </ol>
            </div>
          </div>
          <div className="SectionRight">
            <div className="ImageContainer">
              <img
                src={Slush}
                alt="Blendz slushy machine"
                className="ContentImages"
                height={"80%"}
                style={{ transform: "scaleX(-1)" }}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Beverages;
